import { getModules } from 'Redux/Query/Module/GetModules/GetModules';

export const getModuleByName = (state) => (name) => {
  return getModules(state).find(module => {
    const regExp = new RegExp(name, 'i');
    return !!module.name.match(regExp);
  });
};
